import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
`;

export const Container = styled.div`
  padding: 1rem 1rem;
  background: ${(props) => props.theme.colors.discrete5};
  height: 100%;
`;
